import { Routes } from '@angular/router';
import { LoginRouteGuardService } from './services/_core/login-route-guard/login-route-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: 'patient/registration-form',
    loadComponent: () =>
      import('./pages/patient/registration-form/registration-form.page').then(
        (m) => m.RegistrationFormPage
      ),
  },
  {
    path: 'patient/registration-complete',
    loadComponent: () =>
      import('./pages/patient/registration-complete/registration-complete.page').then(
        (m) => m.RegistrationCompletePage
      ),
  },
  {
    path: 'patient/proxy-form',
    loadComponent: () =>
      import('./pages/patient/proxy-form/proxy-form.page').then(
        (m) => m.ProxyFormPage
      ),
  },
  {
    path: 'patient/proxy-complete',
    loadComponent: () =>
      import('./pages/patient/proxy-complete/proxy-complete.page').then(
        (m) => m.ProxyCompletePage
      ),
  },
  {
    path: 'admin/registration-dashboard',
    canActivate: [LoginRouteGuardService],
    loadComponent: () =>
      import('./pages/admin/registration-dashboard/registration-dashboard.page').then(
        (m) => m.RegistrationDashboardPage
      ),
  },
  {
    path: 'admin/users/new',
    canActivate: [LoginRouteGuardService],
    loadComponent: () =>
      import('./pages/admin/add-edit-user/add-edit-user.page').then(
        (m) => m.AddEditUserPage
      ),
  },
  {
    path: 'admin/users/:userId',
    canActivate: [LoginRouteGuardService],
    loadComponent: () =>
      import('./pages/admin/add-edit-user/add-edit-user.page').then(
        (m) => m.AddEditUserPage
      ),
  },
  {
    path: 'admin/getRegistrations',
    redirectTo: 'admin/registration-dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'login-admin',
    pathMatch: 'full',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'help',
    loadComponent: () => import('./pages/_core/help/help.page').then( m => m.HelpPage)
  },
  {
    path: 'share',
    loadComponent: () => import('./pages/_core/share/share.page').then( m => m.SharePage)
  },
  {
    path: 'check-for-updates',
    loadComponent: () => import('./pages/_core/check-for-updates/check-for-updates.page').then( m => m.CheckForUpdatesPage)
  },
  {
    path: 'help-forgot-pwd',
    loadComponent: () => import('./pages/_core/help-forgot-pwd/help-forgot-pwd.page').then( m => m.HelpForgotPwdPage)
  },
  {
    path: 'feedback-modal',
    loadComponent: () => import('./pages/_core/feedback-modal/feedback-modal.page').then( m => m.FeedbackModalPage)
  },
  {
    path: 'cases-view',
    loadComponent: () => import('./pages/cases-view/cases-view.page').then( m => m.CasesViewPage)
  },
  {
    path: 'my-account',
    canActivate: [LoginRouteGuardService],
    loadComponent: () => import('./pages/_core/my-account/my-account.page').then( m => m.MyAccountPage)
  },
  {
    path: 'language-modal',
    loadComponent: () => import('./pages/_core/language-modal/language-modal.page').then( m => m.LanguageModalPage)
  },
  {
    path: 'language-popover',
    loadComponent: () => import('./pages/_core/language-popover/language-popover.page').then( m => m.LanguagePopoverPage)
  },
  {
    path: 'language-translator',
    loadComponent: () => import('./pages/_core/language-translator/language-translator.page').then( m => m.LanguageTranslatorPage)
  },
  {
    path: 'landing',
    loadComponent: () => import('./pages/landing/landing.page').then( m => m.LandingPage)
  },
  {
    path: 'redirect',
    loadComponent: () => import('./pages/redirect/redirect.page').then( m => m.RedirectPage)
  },
  {
    path: '**',
    redirectTo: '/landing',
  },
];
